import type {LoginCopy} from './useAuth';
import type {GuestCheckoutContext} from 'requests';
import {translate as t} from 'i18n/translator';

export const resultLoginCopy = (kind: 'ai' | 'plagiarism'): LoginCopy => ({
    title: t(`login-${kind}-results-title`),
    subtitle: t(`login-${kind}-results-subtitle`),
});

export const documentLoginCopy = (maxMb: number): LoginCopy => ({
    title: t('login-document-title', {mb: maxMb}),
    subtitle: t('login-document-subtitle'),
});

const PLAN_NAMES = new Map([['plus', 'Plus'], ['premium', 'Premium'], ['pro', 'Pro'], ['enterprise', 'Enterprise']]);

/** Only a server-confirmed payment gets the payment-complete message. Old API
 * responses and unavailable checkout details keep a neutral account-access prompt. */
export const guestClaimLoginCopy = (context?: GuestCheckoutContext | null): LoginCopy => {
    const plan = context?.plan && PLAN_NAMES.get(context.plan);
    return {
        title: context?.trial
            ? t('login-trial-title')
            : plan ? t('login-purchase-plan-title', {plan}) : t('login-purchase-title'),
        subtitle: !context?.trial && context?.payment_confirmed
            ? t('login-purchase-paid-subtitle') : t('login-purchase-subtitle'),
        perks: [],
        footer: null,
    };
};
